import { CategoryInventoryScan } from "@gull";
import { lazy, useContext } from "react";

const Articles = lazy(() => import("./Articles/Articles/Welcome"));
const Fournisseurs = lazy(()=> import("./Articles/Fournisseurs/Fournisseurs"));
const StockItem = lazy(()=> import("./Articles/Stock/StockItem"));
const FournisseursDetailsTab = lazy(()=> import("./Articles/Fournisseurs/FournisseursDetailsTab"));
const FamilleArticle = lazy(() => import("./Articles/FamilleArticle/FamilleArticle"));
const Marques = lazy(() => import("./Articles/Marques/Marques"));
const ArticleDetail = lazy(() => import("./Articles/ArticleDetail/ArticleDetail"));
const Promotion = lazy(() => import("./Articles/Promotion/Promotion"));
const PromotionDetail = lazy(() => import("./Articles/Promotion/PromotionDetail"));
const ListeArticleTable = lazy(() => import("./Articles/ListeArticle/ListeArticleTable"));
const ListeArticleDetailErp = lazy(() => import("./Articles/ListeArticle/ListeArticleDetailErp"));
const BonCommande = lazy(() => import("./BonCommande/BonCommande"));
const BonCommandeDetail = lazy(() => import("./BonCommande/BonCommandeDetail"));
const Shipment = lazy(() => import("./Shipment/Shipment"));
const ShipmentDetail = lazy(() => import("./Shipment/ShipmentDetail"));
const ReceiptVoucher = lazy(() => import("./Shipment/ReceiptVoucher"));
const AutoRestockMenu = lazy(() => import("./Reassort/AutoRestockMenu"));
const AutoReassortParent = lazy(() => import("./Reassort/AutoReassortParent"));
const RppslPackDetail = lazy(() => import("./Reassort/RppslPack/RppslPackDetail"));
const AutoRestockFournisseurMenu = lazy(() => import("./Reassort/AutoRestockFournisseurMenu"));
const InternalRestockException = lazy(() => import("./ReassortException/InternalRestockException"));
const TransferOrder = lazy(() => import("./TransferOrder/TransferOrder"));
const ToDetail = lazy(() => import("./TransferOrder/ToDetail"));
const Session = lazy(() => import("./Session/Session"));
const TicketCommandesClientDevis = lazy(() => import("./TicketCommandesClientDevis/TicketCommandesClientDevis"));
const DetailTicketAdmin = lazy(() => import("@gull/components/DetailTicketAdmin/DetailTicketAdmin"));
const DetailCommandeAdmin = lazy(() => import("@gull/components/DetailCommandeAdmin/DetailCommandeAdmin"));
const DetailDevisAdmin = lazy(() => import("@gull/components/DetailDevisAdmin/DetailDevisAdmin"));
const Inventory = lazy(() => import("./Inventaire/Inventory"));
const InventoryReport = lazy(() => import("./Inventaire/InventoryReport"));
const CategoryInventory = lazy(() => import("./Inventaire/Comp/CategoryInventory"));
const CategoryInventoryAdminScanMasse = lazy(() => import("./Inventaire/Comp/CategoryInventoryAdminScanMasse"));
const ZoneInventory = lazy(() => import("./Inventaire/Comp/ZoneInventory"));
const ZoneInventoryAdminScan = lazy(() => import("./Inventaire/Comp/ZoneInventoryAdminScan"));
const BinsInventory = lazy(() => import("./Inventaire/Comp/BinsInventory"));
const BinsInventoryAdminScan = lazy(() => import("./Inventaire/Comp/BinsInventoryAdminScan"));
const ObjectifPos = lazy(() => import("./ObjectifPos/ObjectifPos"));
const TurnoverPosPage = lazy(() => import("./CA/TurnoverPosPage"));
const NotificationListErp = lazy(() => import("./Notification/NotificationListErp"));
const NotificationDetailErp = lazy(() => import("./Notification/NotificationDetailErp"));
const LicenceNotificationDetail = lazy(() => import("../notifications/LicenceNotificationDetail"));
const MatchInternalId = lazy(() => import("./MatchInternalId/MatchInternalId"));
const HistoriqueDetail = lazy(() => import("./Historique/HistoriqueDetail"));
const GiftCardListErp = lazy(() => import("./GiftCard/GiftCardListErp"));
const HistoriqueStockAdjustment = lazy(() => import("./HistoriqueMenu/HistoStockAsjustment/HistoriqueStockAdjustment"));
const RemiseManuelle = lazy(() => import("./HistoriqueMenu/RemiseManuelle/RemiseManuelle"));
const CancellationReceipt = lazy(() => import("./HistoriqueMenu/CancellationReceipt/CancellationReceipt"));
const HistoriqueAttemptedStockAdjustment = lazy (()=> import("./HistoriqueMenu/HistoriqueAttemptedStockAdjustment"))
const FideliteWelcome = lazy (()=> import("./Fidelite/FideliteWelcome"))
const PlanFideliteDetail = lazy (()=> import("./Fidelite/PlanFideliteDetail/PlanFideliteDetail.jsx"))
const RecompenseFideliteConfig = lazy (()=> import("./Fidelite/RecompenseFideliteConfig/RecompenseFideliteConfig"))
const FideliteListErp = lazy(() => import("./Fidelite/FideliteListErp/FideliteListErp"));
const CashOutGroupeErp = lazy (()=> import("./CashOutGroupeErp/CashOutGroupeErp"))
const ErpPlanTable = lazy(() => import("./PlanTable/ErpPlanTable"))
const ClientWelcome = lazy (()=> import("./Client/ClientWelcome"))
const ClientProfilErp = lazy (()=> import("./Client/ClientDetail/ClientProfilErp"))
const ErpReport = lazy (()=> import("./ReportPbi/ErpReport"))
const PeripheriqueErp = lazy (()=> import("./PeripheriqueErp/PeripheriqueErp"))
const ComptabiliteMain = lazy (()=> import("./Comptabilite/ComptabiliteMain"))
const GenerateUpc = lazy (()=> import("./Articles/GenerateUpc/GenerateUpc"))
const ItemTransform = lazy (()=> import("./Articles/ItemTransform/ItemTransform"))
const SupplementList = lazy (()=> import("./Articles/SupplementList/SupplementList"))
const SupplementListDetail = lazy (()=> import("./Articles/SupplementList/SupplementListDetail"))
const Abonnement = lazy (()=> import("./Articles/Abonnement/Abonnement"))
const AbonnementCardListErp = lazy(() => import("./AbonnementCard/AbonnementCardListErp"));
const InactiveStockArticles = lazy(() => import("./HistoriqueMenu/InactiveStockArticles/InactiveStockArticles"));

const erpRoutes = [
    {
        path: "/erp/welcome",
        id: "article_list",
        name: "[ERP] Liste des articles - /erp/welcome",
        component: Articles
    },
    // {//plus utilisé, peut être supprimé si pas de bug signalé depuis 13/05/2026
    //     path: "/erp/item",
    //     component: Articles
    // },
    {
        path: "/erp/article/edit/:id",
        id: "erp_article_edit",
        name: "[ERP] Fiche article - /erp/article/edit/:id",
        component: ArticleDetail
    },
    {
        path: "/erp/stock/item",
        id: "erp_stock_item",
        name: "[ERP] Stock par article - /erp/stock/item",
        component: StockItem
    },
    {
        path: "/erp/itemfamily",
        id: "erp_item_family",
        name: "[ERP] Familles d'articles - /erp/itemfamily",
        component: FamilleArticle
    },
    {
        path: "/erp/items-list",
        id: "erp_items_list",
        name: "[ERP] Liste d'articles - /erp/items-list",
        component: ListeArticleTable
    },
    {
        path: "/erp/items-list-detail/:id",
        id: "erp_items_list_detail",
        name: "[ERP] Détail article (liste) - /erp/items-list-detail/:id",
        component: ListeArticleDetailErp
    },
    {
        path: "/erp/itemtransform",
        id: "erp_item_transform",
        // name: "[ERP] Transformation d'article - /erp/itemtransform",
        component: ItemTransform
    },
    {
        path: "/erp/supplement-list",
        id: "erp_supplement_list",
        // name: "[ERP] Liste des suppléments - /erp/supplement-list",
        component: SupplementList
    },
    {
        path: "/erp/supplement-list-detail/:id",
        id: "erp_supplement_list_detail",
        // name: "[ERP] Détail supplément - /erp/supplement-list-detail/:id",
        component: SupplementListDetail
    },
    {
        path: "/erp/abonnement",
        id: "erp_abonnement",
        // name: "[ERP] Abonnements - /erp/abonnement",
        component: Abonnement
    },
    {
        path: "/erp/items-generateupc",
        id: "erp_generate_upc",
        name: "[ERP] Génération codes UPC - /erp/items-generateupc",
        component: GenerateUpc
    },
    {
        exact:true,
        path: "/erp/brand",
        id: "erp_brand",
        name: "[ERP] Marques - /erp/brand",
        component: Marques
    },
    {
        exact:true,
        path: "/erp/provider",
        id: "erp_provider",
        name: "[ERP] Fournisseurs - /erp/provider",
        component: Fournisseurs
    },
    {
        path: "/erp/provider/details/:id",
        id: "erp_provider_details",
        name: "[ERP] Détail fournisseur - /erp/provider/details/:id",
        component: FournisseursDetailsTab
    },
    {
        exact:true,
        path: "/erp/promotion",
        id: "erp_promotion",
        name: "[ERP] Promotions - /erp/promotion",
        component: Promotion
    },
    {
        path: "/erp/promotion/detail/:id",
        id: "erp_promotion_detail",
        name: "[ERP] Détail promotion - /erp/promotion/detail/:id",
        component: PromotionDetail
    },
    {
        exact:true,
        path: "/erp/inventory",
        id: "erp_inventory",
        // name: "[ERP] Inventaire - /erp/inventory",
        component: Inventory
    },
    // {
    //     exact:true,
    //     path: "/erp/inventory/import",
    //     component: InventoryImport
    // },
    {
        exact:true,
        path: "/erp/inventory/report/:id",
        id: "erp_inventory_report",
        // name: "[ERP] Rapport d'inventaire - /erp/inventory/report/:id",
        component: InventoryReport
    },
    {
        exact:true,
        path: "/erp/inventory/categorie/:id/:zoneid",
        id: "erp_inventory_category",
        name: "[ERP] Inventaire par catégorie - /erp/inventory/categorie/:id/:zoneid",
        component: CategoryInventory
    },
    {
        exact:true,
        path: "/erp/inventory/categorie/:id/:zoneid/:rhid",
        id: "erp_inventory_category_scan_masse",
        // name: "[ERP] Inventaire catégorie - scan de masse - /erp/inventory/categorie/:id/:zoneid/:rhid",
        component: CategoryInventoryAdminScanMasse
    },
    {
        exact:true,
        path: "/erp/inventory/zone/:id/:zoneid",
        id: "erp_inventory_zone",
        name: "[ERP] Inventaire par zone - /erp/inventory/zone/:id/:zoneid",
        component: ZoneInventory
    },
    {
        exact:true,
        path: "/erp/inventory/zone/:id/:zoneid/:zoneinventoryid/:rhid",
        id: "erp_inventory_zone_scan",
        // name: "[ERP] Inventaire zone - scan - /erp/inventory/zone/:id/:zoneid/:zoneinventoryid/:rhid",
        component: ZoneInventoryAdminScan
    },
    {
        exact:true,
        path: "/erp/inventory/bins/:id/:zoneid",
        id: "erp_inventory_bins",
        name: "[ERP] Inventaire par bin - /erp/inventory/bins/:id/:zoneid",
        component: BinsInventory
    },
    {
        exact:true,
        path: "/erp/inventory/bins/:id/:zoneid/:binsinventoryid/:binsid/:binsnum/:rhid",
        id: "erp_inventory_bins_scan",
        // name: "[ERP] Inventaire bin - scan - /erp/inventory/bins/:id/:zoneid/:binsinventoryid/:binsid/:binsnum/:rhid",
        component: BinsInventoryAdminScan
    },
    {
        path: "/erp/internal-id-match",
        id: "erp_internal_id_match",
        name: "[ERP] Correspondance ID interne - /erp/internal-id-match",
        component: MatchInternalId
    },
    {
        exact:true,
        path: "/erp/purchase-order",
        id: "erp_purchase_order",
        name: "[ERP] Bons de commande - /erp/purchase-order",
        component: BonCommande
    },
    {
        path: "/erp/purchase-order/details/:id",
        id: "erp_purchase_order_details",
        name: "[ERP] Détail bon de commande - /erp/purchase-order/details/:id",
        component: BonCommandeDetail
    },
    {
        exact:true,
        path: "/erp/shipment",
        id: "erp_shipment",
        // name: "[ERP] Livraisons - /erp/shipment",
        component: Shipment
    },
    {
        path: "/erp/shipment/details/:id",
        id: "erp_shipment_details",
        // name: "[ERP] Détail livraison - /erp/shipment/details/:id",
        component: ShipmentDetail
    },
    {
        path: "/erp/shipment/receipt-voucher/:shipmentid/:cartonnumber",
        id: "erp_shipment_receipt_voucher",
        // name: "[ERP] Bon de réception - /erp/shipment/receipt-voucher/:shipmentid/:cartonnumber",
        component: ReceiptVoucher
    },
    {
        exact:true,
        path: "/erp/transfer-order",
        id: "erp_transfer_order",
        name: "[ERP] Ordres de transfert - /erp/transfer-order",
        component: TransferOrder
    },
    {
        path: "/erp/transfer-order/details/:id",
        id: "erp_transfer_order_details",
        name: "[ERP] Détail ordre de transfert - /erp/transfer-order/details/:id",
        component: ToDetail
    },
    {
        exact:true,
        path: "/erp/automatic-restock/parent-item/:id",
        id: "erp_auto_restock_parent_item",
        // name: "[ERP] Réassort auto - article parent - /erp/automatic-restock/parent-item/:id",
        component: AutoReassortParent
    },
    {
        exact:true,
        path: "/erp/automatic-restock/:id?/:cur_page?",
        id: "erp_auto_restock_menu",
        name: "[ERP] Réassort automatique - /erp/automatic-restock/:id?/:cur_page?",
        component: AutoRestockMenu
    },
    {
        path: "/erp/rppsl-pack/detail/:id",
        id: "erp_rppsl_pack_detail",
        // name: "[ERP] Détail pack RPPSL - /erp/rppsl-pack/detail/:id",
        component: RppslPackDetail
    },
    {
        exact:true,
        path: "/erp/automatic-restock-supplier",
        id: "erp_auto_restock_supplier",
        name: "[ERP] Réassort automatique fournisseur - /erp/automatic-restock-supplier",
        component: AutoRestockFournisseurMenu
    },
    {
        exact:true,
        path: "/erp/internal-restock-exception",
        id: "erp_internal_restock_exception",
        name: "[ERP] Exceptions de réassort interne - /erp/internal-restock-exception",
        component: InternalRestockException
    },
    {
        path: "/erp/caisse/session",
        id: "erp_caisse_session",
        name: "[ERP] Sessions de caisse - /erp/caisse/session",
        component: Session
    },
    {
        exact:true,
        path: "/erp/caisse/cashout",
        id: "erp_caisse_cashout",
        name: "[ERP] Cash-out groupé - /erp/caisse/cashout",
        component: CashOutGroupeErp
    },
    {
        path: "/erp/objectifpos",
        id: "erp_objectif_pos",
        name: "[ERP] Objectifs POS - /erp/objectifpos",
        component: ObjectifPos
    },
    {
        path: "/erp/turnoverpos",
        id: "erp_turnover_pos",
        name: "[ERP] Chiffre d'affaires POS - /erp/turnoverpos",
        component: TurnoverPosPage
    },
    {
        exact:true,
        path: "/erp/caisse/ticket",
        id: "erp_caisse_ticket",
        name: "[ERP] Tickets, commandes et devis - /erp/caisse/ticket",
        component: TicketCommandesClientDevis
    },
    {
        exact:true,
        path: "/erp/caisse/ticket/:ticketId",
        id: "erp_caisse_ticket_detail",
        name: "[ERP] Détail ticket - /erp/caisse/ticket/:ticketId",
        component: DetailTicketAdmin
    },
    {
        exact:true,
        path: "/erp/caisse/sales-order/:saleOrderId",
        id: "erp_caisse_sales_order_detail",
        name: "[ERP] Détail commande client - /erp/caisse/sales-order/:saleOrderId",
        component: DetailCommandeAdmin
    },
    {
        exact:true,
        path: "/erp/caisse/devis/:devisId",
        id: "erp_caisse_devis_detail",
        name: "[ERP] Détail devis - /erp/caisse/devis/:devisId",
        component: DetailDevisAdmin
    },
    {
        exact:true,
        path: "/erp/caisse/plantable",
        id: "erp_caisse_plantable",
        // name: "[ERP] Plan de salle - /erp/caisse/plantable",
        component: ErpPlanTable
    },
    {
        exact:true,
        path: "/erp/client",
        id: "erp_client",
        name: "[ERP] Clients - /erp/client",
        component: ClientWelcome
    },
    {
        exact:true,
        path: "/erp/client/detail/:id",
        id: "erp_client_detail",
        name: "[ERP] Profil client - /erp/client/detail/:id",
        component: ClientProfilErp
    },
    {
        exact:true,
        path: "/erp/loyalty-plan",
        id: "erp_loyalty_plan",
        name: "[ERP] Plans de fidélité - /erp/loyalty-plan",
        component: FideliteWelcome
    },
    {
        exact:true,
        path: "/erp/loyalty-plan/detail/:id",
        id: "erp_loyalty_plan_detail",
        name: "[ERP] Détail plan de fidélité - /erp/loyalty-plan/detail/:id",
        component: PlanFideliteDetail
    },
    {
        exact:true,
        path: "/erp/loyalty-rewards-configuration",
        id: "erp_loyalty_rewards_configuration",
        name: "[ERP] Configuration des récompenses fidélité - /erp/loyalty-rewards-configuration",
        component: RecompenseFideliteConfig
    },
    {
        exact:true,
        path: "/erp/caisse/fidelite",
        id: "erp_caisse_fidelite",
        name: "[ERP] Fidélité - /erp/caisse/fidelite",
        component: FideliteListErp
    },
    {
        exact:true,
        path: "/erp/caisse/giftcard",
        id: "erp_caisse_giftcard",
        name: "[ERP] Cartes cadeaux - /erp/caisse/giftcard",
        component: GiftCardListErp
    },
    {
        exact:true,
        path: "/erp/caisse/abonnementcard",
        id: "erp_caisse_abonnementcard",
        // name: "[ERP] Cartes d'abonnement - /erp/caisse/abonnementcard",
        component: AbonnementCardListErp
    },
    {
        path: "/erp/historical/stock-adjustment",
        id: "erp_historical_stock_adjustment",
        name: "[ERP] Historique des ajustements de stock - /erp/historical/stock-adjustment",
        component: HistoriqueStockAdjustment
    },
    {
        path: "/erp/historical/stock-adjustment-attempt",
        id: "erp_historical_stock_adjustment_attempt",
        name: "[ERP] Historique des tentatives d'ajustement de stock - /erp/historical/stock-adjustment-attempt",
        component: HistoriqueAttemptedStockAdjustment
    },
    {
        path: "/erp/historical/manual-deposit",
        id: "erp_historical_manual_deposit",
        name: "[ERP] Historique des remises manuelles - /erp/historical/manual-deposit",
        component: RemiseManuelle
    },
    {
        path: "/erp/historical/cancellation-on-receipt",
        id: "erp_historical_cancellation_receipt",
        name: "[ERP] Historique des annulations de réception - /erp/historical/cancellation-on-receipt",
        component: CancellationReceipt
    },
    {
        path: "/erp/historical/inactive-stock-articles",
        id: "erp_historical_inactive_stock_articles",
        name: "[ERP] Articles en stock inactifs - /erp/historical/inactive-stock-articles",
        component: InactiveStockArticles
    },
    {
        path: "/erp/historique/edit/:id",
        id: "erp_historique_edit",
        // name: "[ERP] Détail historique - /erp/historique/edit/:id",
        component: HistoriqueDetail
    },
    {
        exact:true,
        path: "/erp/report",
        id: "erp_report",
        // name: "[ERP] Rapport Power BI - /erp/report",
        component: ErpReport
    },
    {
        path: "/erp/accounting",
        id: "erp_accounting",
        name: "[ERP] Comptabilité - /erp/accounting",
        component: ComptabiliteMain
    },
    {
        path: "/erp/notifications/list",
        id: "erp_notifications_list",
        // name: "[ERP] Liste des notifications - /erp/notifications/list",
        component: NotificationListErp
    },
    {
        path: "/erp/notifications/detail/:id",
        id: "erp_notifications_detail",
        // name: "[ERP] Détail notification - /erp/notifications/detail/:id",
        component: NotificationDetailErp
    },
    {
        path: "/erp/notifications/licence-notification/:licenceNotificationId",
        id: "erp_notifications_licence_detail",
        // name: "[ERP] Détail notification licence - /erp/notifications/licence-notification/:licenceNotificationId",
        component: LicenceNotificationDetail
    },
    {
        exact:true,
        path: "/erp/peripherals",
        id: "erp_peripherals",
        // name: "[ERP] Périphériques - /erp/peripherals",
        component: PeripheriqueErp
    },
    // {
    //     path: "/erp/billing/template",
    //     component: TemplateBilling
    // },
    // {
    //     path: "/erp/email/template",
    //     component: TemplateEmail
    // },
  ];
  
  export default erpRoutes; 